import { Description, ReturnLink, Title, Wrapper } from '../McpConsent.styles';

const McpConsentSuccess = ({ redirectUrl }) => (
	<Wrapper>
		<Title>Access granted</Title>
		<Description>Returning to Claude...</Description>
		<ReturnLink href={redirectUrl}>Continue to Claude</ReturnLink>
	</Wrapper>
);

export default McpConsentSuccess;
